import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { fetchTestResultSummary } from "../../../services/api";
import "./TestResult.css";

/* ─── SVG Icons ────────────────────────────────────────────────────────────── */
const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const IconX = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const IconMinus = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
const IconEye = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
  </svg>
);
const IconTarget = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" />
  </svg>
);
const IconTrophy = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="8 21 12 17 16 21" />
    <path d="M4 4h16v7a8 8 0 0 1-16 0V4z" />
    <path d="M4 7H2a2 2 0 0 0 0 4h2" />
    <path d="M20 7h2a2 2 0 0 1 0 4h-2" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);
// const IconRefresh = () => (
//   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <polyline points="1 4 1 10 7 10" />
//     <path d="M3.51 15a9 9 0 1 0 .49-3.5" />
//   </svg>
// );
const IconChevronRight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const IconStar = () => (
  <svg viewBox="0 0 24 24" fill="#fbbf24" stroke="#fbbf24" strokeWidth="1">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);
const IconLightbulb = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="9" y1="18" x2="15" y2="18" /><line x1="10" y1="22" x2="14" y2="22" />
    <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14" />
  </svg>
);
const IconBrain = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.5 2a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-4.96.5A2.5 2.5 0 0 1 4.5 17.5v-1A2.5 2.5 0 0 1 3 14.24V11a2.5 2.5 0 0 1 1.04-2.03A2.5 2.5 0 0 1 6 5.5a2.5 2.5 0 0 1 3.5-3.5z" />
    <path d="M14.5 2a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 4.96.5A2.5 2.5 0 0 0 19.5 17.5v-1A2.5 2.5 0 0 0 21 14.24V11a2.5 2.5 0 0 0-1.04-2.03A2.5 2.5 0 0 0 18 5.5a2.5 2.5 0 0 0-3.5-3.5z" />
  </svg>
);
const IconBook = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
);
const IconCalculator = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="2" width="16" height="20" rx="2" />
    <line x1="8" y1="6" x2="16" y2="6" />
    <line x1="8" y1="11" x2="8" y2="11.01" /><line x1="12" y1="11" x2="12" y2="11.01" /><line x1="16" y1="11" x2="16" y2="11.01" />
    <line x1="8" y1="15" x2="8" y2="15.01" /><line x1="12" y1="15" x2="12" y2="15.01" /><line x1="16" y1="15" x2="16" y2="15.01" />
    <line x1="8" y1="19" x2="8" y2="19.01" /><line x1="12" y1="19" x2="12" y2="19.01" /><line x1="16" y1="19" x2="16" y2="19.01" />
  </svg>
);
const IconGlobe = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);
const IconLayers = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 2 7 12 12 22 7 12 2" />
    <polyline points="2 17 12 22 22 17" />
    <polyline points="2 12 12 17 22 12" />
  </svg>
);

/* ─── Animated SVG score ring ───────────────────────────────────────────────── */
interface ScoreRingProps {
  score: number;
  total: number;
  label: string;
  color: string;
  size?: number;
}
const ScoreRing: React.FC<ScoreRingProps> = ({ score, total, label, color, size = 120 }) => {
  const pct    = total > 0 ? score / total : 0;
  const r      = 44;
  const circ   = 2 * Math.PI * r;
  const dash   = pct * circ;

  return (
    <div className="tr-ring-wrap" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 100 100">
        <circle cx="50" cy="50" r={r} fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="8" />
        <circle
          cx="50" cy="50" r={r}
          fill="none"
          stroke={color}
          strokeWidth="8"
          strokeLinecap="round"
          strokeDasharray={`${dash} ${circ}`}
          strokeDashoffset={circ * 0.25}
          style={{ transition: "stroke-dasharray 1.2s ease" }}
        />
      </svg>
      <div className="tr-ring-inner">
        <div className="tr-ring-score">{score}</div>
        <div className="tr-ring-label">{label}</div>
      </div>
    </div>
  );
};

/* ─── Animated progress bar ────────────────────────────────────────────────── */
interface ProgressBarProps {
  value: number;
  total: number;
  color: string;
  label: string;
  count: number;
  icon: React.ReactNode;
}
const ProgressBar: React.FC<ProgressBarProps> = ({ value, total, color, label, count, icon }) => {
  const pct = total > 0 ? Math.round((value / total) * 100) : 0;
  return (
    <div className="tr-progress-row">
      <div className="tr-progress-head">
        <div className="tr-progress-label">
          <span className="tr-progress-icon" style={{ color, background: `${color}18` }}>{icon}</span>
          {label}
        </div>
        <div className="tr-progress-stats">
          <span className="tr-progress-count" style={{ color }}>{count}</span>
          <span className="tr-progress-pct">{pct}%</span>
        </div>
      </div>
      <div className="tr-progress-track">
        <div
          className="tr-progress-fill"
          style={{ width: `${pct}%`, background: color }}
        />
      </div>
    </div>
  );
};

/* ─── Section theming (Reasoning / English / Quant / GK …) ────────────────── */
const SECTION_THEMES: Record<string, { color: string; bg: string; icon: React.ReactNode }> = {
  reasoning:              { color: "#7c3aed", bg: "#f0eeff", icon: <IconBrain /> },
  "logical reasoning":    { color: "#7c3aed", bg: "#f0eeff", icon: <IconBrain /> },
  english:                { color: "#0284c7", bg: "#eff8ff", icon: <IconBook /> },
  "english language":     { color: "#0284c7", bg: "#eff8ff", icon: <IconBook /> },
  quant:                  { color: "#ea580c", bg: "#fff7ed", icon: <IconCalculator /> },
  quantitative:           { color: "#ea580c", bg: "#fff7ed", icon: <IconCalculator /> },
  "quantitative aptitude":{ color: "#ea580c", bg: "#fff7ed", icon: <IconCalculator /> },
  maths:                  { color: "#ea580c", bg: "#fff7ed", icon: <IconCalculator /> },
  math:                   { color: "#ea580c", bg: "#fff7ed", icon: <IconCalculator /> },
  mathematics:            { color: "#ea580c", bg: "#fff7ed", icon: <IconCalculator /> },
  gk:                     { color: "#16a34a", bg: "#f0fdf4", icon: <IconGlobe /> },
  "general knowledge":    { color: "#16a34a", bg: "#f0fdf4", icon: <IconGlobe /> },
  "general awareness":    { color: "#16a34a", bg: "#f0fdf4", icon: <IconGlobe /> },
  gs:                     { color: "#16a34a", bg: "#f0fdf4", icon: <IconGlobe /> },
};
const SECTION_PALETTE = [
  { color: "#0d9e8a", bg: "#e6faf7" },
  { color: "#7c3aed", bg: "#f0eeff" },
  { color: "#ea580c", bg: "#fff7ed" },
  { color: "#0284c7", bg: "#eff8ff" },
  { color: "#dc2626", bg: "#fef2f2" },
  { color: "#16a34a", bg: "#f0fdf4" },
];
const getSectionTheme = (name: string, idx: number) => {
  const key = (name || "").trim().toLowerCase();
  if (SECTION_THEMES[key]) return SECTION_THEMES[key];
  const palette = SECTION_PALETTE[idx % SECTION_PALETTE.length];
  return { ...palette, icon: <IconLayers /> };
};

/* ═══════════════════════════════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════════════════════════════ */
const TestResult: React.FC = () => {
  const { slug, test_id } = useParams<{ slug: string; test_id: string }>();
  const [result,  setResult]  = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchResult = async () => {
      const user = JSON.parse(localStorage.getItem("user") || "null");
      if (!user) { navigate("/login"); return; }
      try {
        const res = await fetchTestResultSummary(user.id, test_id);
        setResult(res.data);
      } catch {
        navigate("/");
      } finally {
        setLoading(false);
      }
    };
    if (test_id) fetchResult();
  }, [test_id, navigate]);

  if (loading) return (
    <div className="tr-loading">
      <div className="tr-loading-ring" />
      <p>Loading your results…</p>
    </div>
  );

  if (!result) return null;

  const user         = JSON.parse(localStorage.getItem("user") || "null");
  const userRankIdx  = result.leaderboard.findIndex((r: any) => String(r.userId) === String(user?.id));
  const userRank     = userRankIdx !== -1 ? userRankIdx + 1 : null;
  const accuracy     = result.totalQuestions > 0
    ? Math.round((result.correct / result.totalQuestions) * 100)
    : 0;
  const notAnswered  = result.notAnswered ?? (result.totalQuestions - result.answered);
  const isExcellent  = accuracy >= 70;

  const SUMMARY_COLS = [
    { label: "Total",         value: result.totalQuestions    },
    { label: "Answered",      value: result.answered          },
    { label: "Not Answered",  value: notAnswered              },
    { label: "Marked",        value: result.markedForReview   },
    { label: "Not Visited",   value: result.notVisited        },
    { label: "Correct",       value: result.correct           },
    { label: "Incorrect",     value: result.incorrect         },
    { label: "Marks",         value: result.totalMarks        },
  ];

  const INSIGHTS = [
    {
      icon: "📊",
      text: `You attempted ${result.answered} out of ${result.totalQuestions} questions (${Math.round((result.answered / result.totalQuestions) * 100)}% attempt rate).`,
    },
    {
      icon: "🎯",
      text: `Your accuracy is ${accuracy}%. ${accuracy >= 75 ? "Great job — keep it up!" : "Try to push it above 75% next time."}`,
    },
    {
      icon: "⚡",
      text: `You got ${result.incorrect} incorrect answers. Reviewing solutions will help you avoid these mistakes.`,
    },
    {
      icon: "🏅",
      text: userRank
        ? `You ranked #${userRank} on the leaderboard${userRank <= 3 ? " — outstanding!" : ". Keep pushing higher!"}`
        : "Complete more tests to appear on the leaderboard.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>{result.test_name} — Result | Acadebility</title>
        <meta name="description" content={`View your result for ${result.test_name}`} />
      </Helmet>

      {/* ══════════════════════════════════════════════════════════
          HERO BANNER
      ══════════════════════════════════════════════════════════ */}
      <div className="tr-hero">
        <div className="tr-hero-inner">
          {/* Breadcrumb */}
          <nav className="tr-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <Link to="/blogs/all-blogs/test_series">Test Series</Link>
            <span>/</span>
            <span>{result.test_name}</span>
          </nav>

          <h1 className="tr-hero-title">{result.test_name}</h1>
          <p className="tr-hero-sub">Your exam results are ready — review your performance below</p>

          {/* Hero stat pills */}
          <div className="tr-hero-pills">
            <div className="tr-hero-pill">
              <span>📋</span>
              {result.totalQuestions} Questions
            </div>
            <div className="tr-hero-pill">
              <span>🎯</span>
              {accuracy}% Accuracy
            </div>
            {userRank && (
              <div className="tr-hero-pill tr-pill-gold">
                <span>🏆</span>
                Rank #{userRank}
              </div>
            )}
            <div className={`tr-hero-pill ${isExcellent ? "tr-pill-green" : "tr-pill-orange"}`}>
              {isExcellent ? "🚀 Excellent" : "📈 Keep Improving"}
            </div>
          </div>
        </div>

        {/* Decorative blobs */}
        <div className="tr-hero-blob tr-blob-1" />
        <div className="tr-hero-blob tr-blob-2" />
      </div>

      {/* ══════════════════════════════════════════════════════════
          PAGE BODY
      ══════════════════════════════════════════════════════════ */}
      <div className="tr-page">
        <div className="tr-layout">

          {/* ── LEFT / MAIN COLUMN ── */}
          <div className="tr-main">

            {/* ── SCORE OVERVIEW CARD ── */}
            <div className="tr-card tr-score-card">
              <div className="tr-score-card-bg" />

              <div className="tr-score-overview">
                {/* Main score ring */}
                <div className="tr-score-left">
                  <ScoreRing
                    score={result.totalMarks}
                    total={result.totalQuestions}
                    label="Marks"
                    color="#ffe066"
                    size={140}
                  />
                  <div className="tr-score-title">Performance Summary</div>
                </div>

                {/* Stat columns */}
                <div className="tr-score-stats">
                  <div className="tr-score-stat tr-ss-green">
                    <div className="tr-ss-icon"><IconCheck /></div>
                    <div className="tr-ss-val">{result.correct}</div>
                    <div className="tr-ss-label">Correct</div>
                  </div>
                  <div className="tr-score-stat tr-ss-red">
                    <div className="tr-ss-icon"><IconX /></div>
                    <div className="tr-ss-val">{result.incorrect}</div>
                    <div className="tr-ss-label">Incorrect</div>
                  </div>
                  <div className="tr-score-stat tr-ss-gray">
                    <div className="tr-ss-icon"><IconMinus /></div>
                    <div className="tr-ss-val">{notAnswered}</div>
                    <div className="tr-ss-label">Skipped</div>
                  </div>
                  <div className="tr-score-stat tr-ss-teal">
                    <div className="tr-ss-icon"><IconTarget /></div>
                    <div className="tr-ss-val">{accuracy}%</div>
                    <div className="tr-ss-label">Accuracy</div>
                  </div>
                  {userRank && (
                    <div className="tr-score-stat tr-ss-gold">
                      <div className="tr-ss-icon"><IconTrophy /></div>
                      <div className="tr-ss-val">#{userRank}</div>
                      <div className="tr-ss-label">Your Rank</div>
                    </div>
                  )}
                </div>
              </div>

              {/* Status badge */}
              <div className={`tr-status-badge ${isExcellent ? "tr-badge-excellent" : "tr-badge-improve"}`}>
                {isExcellent ? "🚀 Excellent Performance!" : "📈 Keep Improving — You're getting there!"}
              </div>
            </div>

            {/* ── PERFORMANCE BREAKDOWN ── */}
            <div className="tr-card tr-breakdown-card">
              <div className="tr-card-head">
                <div className="tr-card-icon tr-icon-teal"><IconTarget /></div>
                <div>
                  <h2 className="tr-card-title">Performance Breakdown</h2>
                  <p className="tr-card-sub">Visual breakdown of your attempt quality</p>
                </div>
              </div>

              <div className="tr-progress-list">
                <ProgressBar
                  label="Correct Answers"
                  count={result.correct}
                  value={result.correct}
                  total={result.totalQuestions}
                  color="#16a34a"
                  icon={<IconCheck />}
                />
                <ProgressBar
                  label="Incorrect Answers"
                  count={result.incorrect}
                  value={result.incorrect}
                  total={result.totalQuestions}
                  color="#dc2626"
                  icon={<IconX />}
                />
                <ProgressBar
                  label="Questions Answered"
                  count={result.answered}
                  value={result.answered}
                  total={result.totalQuestions}
                  color="#0d9e8a"
                  icon={<IconEye />}
                />
                <ProgressBar
                  label="Skipped / Not Answered"
                  count={notAnswered}
                  value={notAnswered}
                  total={result.totalQuestions}
                  color="#6b8c87"
                  icon={<IconMinus />}
                />
              </div>

              {/* Mini donut summary */}
              <div className="tr-breakdown-pills">
                <span className="tr-bp tr-bp-green">{Math.round((result.correct / result.totalQuestions) * 100)}% Correct</span>
                <span className="tr-bp tr-bp-red">{Math.round((result.incorrect / result.totalQuestions) * 100)}% Wrong</span>
                <span className="tr-bp tr-bp-gray">{Math.round((notAnswered / result.totalQuestions) * 100)}% Skipped</span>
              </div>
            </div>

            {/* ── SECTIONAL PERFORMANCE ── */}
            {Array.isArray(result.sectionWiseSummary) && result.sectionWiseSummary.length > 0 && (
              <div className="tr-card tr-sections-card">
                <div className="tr-card-head">
                  <div className="tr-card-icon tr-icon-indigo"><IconLayers /></div>
                  <div>
                    <h2 className="tr-card-title">Sectional Performance</h2>
                    <p className="tr-card-sub">How you performed in each section of the test</p>
                  </div>
                </div>

                <div className="tr-section-grid">
                  {result.sectionWiseSummary.map((sec: any, idx: number) => {
                    const theme = getSectionTheme(sec.section_name, idx);
                    const total = sec.total || 0;
                    const correctPct   = total > 0 ? (sec.correct / total) * 100 : 0;
                    const incorrectPct = total > 0 ? (sec.incorrect / total) * 100 : 0;
                    const skippedPct   = total > 0 ? (sec.notAnswered / total) * 100 : 0;

                    return (
                      <div
                        className="tr-section-item"
                        key={sec.section_name || idx}
                        style={{ ["--sec-color" as any]: theme.color, ["--sec-bg" as any]: theme.bg }}
                      >
                        <div className="tr-section-top">
                          <div className="tr-section-icon">{theme.icon}</div>
                          <div className="tr-section-info">
                            <div className="tr-section-name">{sec.section_name}</div>
                            <div className="tr-section-sub">{total} Question{total === 1 ? "" : "s"}</div>
                          </div>
                          <div className="tr-section-marks">
                            <span>{sec.marks}</span>
                            <small>Marks</small>
                          </div>
                        </div>

                        <div className="tr-section-stack">
                          <div className="tr-section-stack-fill tr-ss-correct"   style={{ width: `${correctPct}%` }} />
                          <div className="tr-section-stack-fill tr-ss-incorrect" style={{ width: `${incorrectPct}%` }} />
                          <div className="tr-section-stack-fill tr-ss-skipped"   style={{ width: `${skippedPct}%` }} />
                        </div>

                        <div className="tr-section-stats">
                          <span className="tr-section-stat"><i className="tr-dot tr-dot-green" />{sec.correct} Correct</span>
                          <span className="tr-section-stat"><i className="tr-dot tr-dot-red" />{sec.incorrect} Incorrect</span>
                          <span className="tr-section-stat"><i className="tr-dot tr-dot-gray" />{sec.notAnswered} Skipped</span>
                          <span className="tr-section-accuracy">{sec.accuracy}% Accuracy</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* ── DETAILED SUMMARY TABLE ── */}
            <div className="tr-card tr-table-card">
              <div className="tr-card-head">
                <div className="tr-card-icon tr-icon-purple">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                    <line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                  </svg>
                </div>
                <div>
                  <h2 className="tr-card-title">Detailed Summary</h2>
                  <p className="tr-card-sub">Complete breakdown of every question status</p>
                </div>
              </div>

              <div className="tr-summary-grid">
                {SUMMARY_COLS.map(col => (
                  <div className="tr-summary-cell" key={col.label}>
                    <div className="tr-summary-val">{col.value ?? "—"}</div>
                    <div className="tr-summary-label">{col.label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* ── SMART INSIGHTS ── */}
            <div className="tr-card tr-insights-card">
              <div className="tr-card-head">
                <div className="tr-card-icon tr-icon-orange"><IconLightbulb /></div>
                <div>
                  <h2 className="tr-card-title">Smart Insights</h2>
                  <p className="tr-card-sub">Personalised feedback based on your performance</p>
                </div>
              </div>

              <div className="tr-insights-list">
                {INSIGHTS.map((ins, i) => (
                  <div className="tr-insight-item" key={i}>
                    <span className="tr-insight-emoji">{ins.icon}</span>
                    <p className="tr-insight-text">{ins.text}</p>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <div className="tr-insights-cta-row">
                <button
                  className="tr-btn-primary"
                  onClick={() => navigate(`/online-tests/test-solutions/${slug}/${test_id}`)}
                >
                  <IconEye />
                  View Solutions & Analysis
                </button>
                {/* <button
                  className="tr-btn-ghost"
                  onClick={() => navigate(`/online-tests/${slug}`)}
                >
                  <IconRefresh />
                  Retake Test
                </button> */}
              </div>
            </div>

          </div>{/* end tr-main */}

          {/* ── RIGHT SIDEBAR: LEADERBOARD ── */}
          <aside className="tr-sidebar">

            {/* Your rank card */}
            {userRank && (
              <div className="tr-rank-card">
                <div className="tr-rank-badge">
                  <IconTrophy />
                  Your Rank
                </div>
                <div className="tr-rank-num">#{userRank}</div>
                <p className="tr-rank-sub">out of {result.leaderboard.length} participants</p>
                <div className={`tr-rank-label ${userRank <= 3 ? "tr-rank-top" : ""}`}>
                  {userRank === 1 ? "🥇 Champion!"
                    : userRank === 2 ? "🥈 Runner-up!"
                    : userRank === 3 ? "🥉 3rd Place!"
                    : userRank <= 10 ? "🎯 Top 10!"
                    : "📈 Keep climbing!"}
                </div>
              </div>
            )}

            {/* Leaderboard */}
            <div className="tr-card tr-leaderboard-card">
              <div className="tr-lb-head">
                <span className="tr-lb-trophy">🏆</span>
                <h3 className="tr-lb-title">Top Rankers</h3>
              </div>

              <div className="tr-lb-list">
                {result.leaderboard.slice(0, 10).map((ranker: any, idx: number) => {
                  const isCurrentUser = String(ranker.userId) === String(user?.id);
                  const medal = idx === 0 ? "🥇" : idx === 1 ? "🥈" : idx === 2 ? "🥉" : null;
                  return (
                    <div
                      key={idx}
                      className={`tr-lb-row${isCurrentUser ? " tr-lb-row-me" : ""}`}
                    >
                      <div className={`tr-lb-rank ${medal ? "tr-lb-medal" : ""}`}>
                        {medal || <span className="tr-lb-num">{idx + 1}</span>}
                      </div>
                      <div className="tr-lb-avatar">
                        {(ranker.firstname?.[0] || "?").toUpperCase()}
                      </div>
                      <div className="tr-lb-info">
                        <div className="tr-lb-name">
                          {ranker.firstname}
                          {isCurrentUser && <span className="tr-lb-you">You</span>}
                        </div>
                        <div className="tr-lb-score">
                          {ranker.correct}/{result.totalQuestions} correct · {ranker.marks} marks
                        </div>
                      </div>
                      <div className="tr-lb-marks">{ranker.marks}</div>
                    </div>
                  );
                })}
              </div>

              {result.leaderboard.length > 10 && (
                <div className="tr-lb-more">+{result.leaderboard.length - 10} more participants</div>
              )}
            </div>

            {/* Quick action card */}
            <div className="tr-card tr-action-card">
              <h3 className="tr-action-title">Next Steps</h3>
              <div className="tr-action-list">
                <button
                  className="tr-action-item"
                  onClick={() => navigate(`/online-tests/test-solutions/${slug}/${test_id}`)}
                >
                  <span className="tr-action-icon tr-ai-teal"><IconEye /></span>
                  <div>
                    <div className="tr-action-label">Review Solutions</div>
                    <div className="tr-action-desc">Understand each answer</div>
                  </div>
                  <IconChevronRight />
                </button>
                {/* <button
                  className="tr-action-item"
                  onClick={() => navigate(`/online-tests/${slug}`)}
                >
                  <span className="tr-action-icon tr-ai-orange"><IconRefresh /></span>
                  <div>
                    <div className="tr-action-label">Retake Test</div>
                    <div className="tr-action-desc">Improve your score</div>
                  </div>
                  <IconChevronRight />
                </button> */}
                <Link to="/online-test-series" className="tr-action-item">
                  <span className="tr-action-icon tr-ai-purple"><IconStar /></span>
                  <div>
                    <div className="tr-action-label">More Tests</div>
                    <div className="tr-action-desc">Browse all test series</div>
                  </div>
                  <IconChevronRight />
                </Link>
              </div>
            </div>

          </aside>
        </div>
      </div>
    </>
  );
};

export default TestResult;